import { render, staticRenderFns } from "./bulkFnfRevoke.vue?vue&type=template&id=2f38e4ad"
import script from "./bulkFnfRevoke.vue?vue&type=script&lang=js"
export * from "./bulkFnfRevoke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports